import {AsyncPipe} from '@angular/common';
import {Component, Input, OnInit} from '@angular/core';
import {Asset} from '@app/asset';
import {IdenticonPipe} from '@app/shared/identicon.pipe';

@Component({
    selector: 'frog-author-inspector',
    templateUrl: './author-inspector.component.html',
    styleUrls: ['./author-inspector.component.scss'],
    imports: [IdenticonPipe, AsyncPipe],
})
export class AuthorInspectorComponent implements OnInit {
    @Input() asset: Asset;

    constructor() {}

    ngOnInit(): void {}
}
